import Alpine from "alpinejs";
import { initHomeMv } from "./modules/homeMv";
import { initHomeLineUpSplide } from "./modules/homeLineUpSplide";
import { initRecipeSplide } from "./modules/recipeSplide";
import { initRecipeContent } from "./modules/recipeContent";
import { initUmakaHerbdori } from "./modules/umakaHerbdori";
import { initAccordion } from "./modules/accordion";
import { initHomeAbout } from "./modules/homeAbout";
import { initTitleAnimation } from "./modules/titleAnimation";
import { initAkadoriMv } from "./modules/akadoriMv";
import { initAkadoriContent } from "./modules/akadoriContent";
import { initRecipeAnimation } from "./modules/recipeAnimation";
import { initHomeLineUpTruckAnimation } from "./modules/homeLineUpTruckAnimation";
import { initHerbdoriMv } from "./modules/herbdoriMv";
import { initHerbdoriContent } from "./modules/herbdoriContent";
import { initHomeJournalAnimation } from "./modules/homeJournalAnimation";
import { smoothScroll } from "./modules/smoothScroll";

(window as any).Alpine = Alpine;

initHomeMv();
initTitleAnimation();
initRecipeAnimation();
initHomeLineUpTruckAnimation();
initHomeAbout();
initAkadoriMv();
initAkadoriContent();
initHerbdoriMv();
initHerbdoriContent();
initHomeJournalAnimation();

document.addEventListener("DOMContentLoaded", () => {
  initAccordion();
  initHomeLineUpSplide();
  initRecipeSplide();
  initRecipeContent();
  initUmakaHerbdori();
  smoothScroll();
});

Alpine.start();
